module.exports = __webpack_public_path__ + "b4ade8d5876f3344a7238db59270811b.jpg";